export class Comodato {
    id: number;
    clienteId: number;
    cliente: String;
    produtoId: number;
    produto: any;
    quantidade: number;
    dtEmprestimo: any;
    dtPrevisaoDevolucao: any;
    dtDevolucao: any;
    observacao: String;
    numeroQuantidade: String;
     


    constructor (id: number, clienteId: number, cliente: String, produtoId: number, produto: any, 
        quantidade:number, dtEmprestimo: any, dtPrevisaoDevolucao: any,
        dtDevolucao: any, observacao: string , numeroQuantidade: String){

            this.id = id;
            this.clienteId = clienteId;
            this.cliente = cliente;
            this.produtoId = produtoId;
            this.produto = produto;
            this.quantidade = quantidade;
            this.dtEmprestimo = dtEmprestimo;
            this.dtPrevisaoDevolucao = dtPrevisaoDevolucao;
            this.dtDevolucao = dtDevolucao;
            this.observacao = observacao;
            this.numeroQuantidade = numeroQuantidade;

        } 
}